import { render, staticRenderFns } from "./InstallControled.vue?vue&type=template&id=10ceb439&scoped=true"
import script from "./InstallControled.vue?vue&type=script&lang=js"
export * from "./InstallControled.vue?vue&type=script&lang=js"
import style0 from "./InstallControled.vue?vue&type=style&index=0&id=10ceb439&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ceb439",
  null
  
)

export default component.exports